import { useSwitchChain } from "wagmi";
import { assets } from "./assets";
import { BrandHeader } from "./components/BrandHeader";
import { BuybackPanel } from "./components/BuybackPanel";
import { Footer } from "./components/Footer";
import { HeroStrip } from "./components/HeroStrip";
import { HolderLpPanel } from "./components/HolderLpPanel";
import { LpTimePanel } from "./components/LpTimePanel";
import { ReferralBuyPanel } from "./components/ReferralBuyPanel";
import { ReferralPanel } from "./components/ReferralPanel";
import { RewardFlow } from "./components/RewardFlow";
import { SplitPanel } from "./components/SplitPanel";
import { StateBanner } from "./components/StateBanner";
import { SummaryCards } from "./components/SummaryCards";
import { TxToast } from "./components/TxToast";
import { useFengniaoDashboard } from "./hooks/useFengniaoDashboard";
import { useReferral } from "./hooks/useReferral";
import { useRewardActions } from "./hooks/useRewardActions";

export function App() {
  const dashboard = useFengniaoDashboard();
  const actions = useRewardActions(dashboard.refetch);
  const referral = useReferral();
  const { switchChain } = useSwitchChain();

  const banner = (() => {
    if (dashboard.missingContracts.length > 0)
      return (
        <StateBanner tone="error">
          必要 vault 地址未配置：{dashboard.missingContracts.join(", ")}
        </StateBanner>
      );
    if (dashboard.wrongNetwork)
      return (
        <StateBanner
          tone="warning"
          action={{ label: "切换到 BSC", onClick: () => switchChain({ chainId: 56 }) }}
        >
          当前网络不是 BSC 主网
        </StateBanner>
      );
    if (!dashboard.stage.tokenBound)
      return (
        <StateBanner tone="info">蜂鸟代币尚未发行，仪表盘将在发行后激活</StateBanner>
      );
    if (!dashboard.stage.lpBound)
      return (
        <StateBanner tone="info">
          等待 LP 池开盘，部分奖励将在 LP 池开盘后启动
        </StateBanner>
      );
    if (dashboard.stage.lpTimePaused)
      return <StateBanner tone="warning">BNB 分红已暂停</StateBanner>;
    return null;
  })();

  return (
    <main className="min-h-screen relative isolate text-ink">
      <div
        className="absolute inset-0 -z-20 bg-cover bg-center"
        style={{ backgroundImage: `url(${assets.dashboardTexture})`, opacity: 0.5 }}
        aria-hidden
      />
      <div className="absolute inset-0 -z-10 bg-hero-glow" aria-hidden />
      <div
        className="absolute inset-0 -z-10 opacity-[0.04] pointer-events-none"
        style={{ backgroundImage: `url(${assets.noise})` }}
        aria-hidden
      />

      <div className="mx-auto max-w-[1200px] px-4 py-4 space-y-6">
        <BrandHeader />
        {banner}
        <HeroStrip
          holderBps={dashboard.split.holderBps}
          lpTimeBps={dashboard.split.lpTimeBps}
          burnBps={dashboard.split.burnBps}
        />
        <SummaryCards
          tokenSymbol={dashboard.token.symbol}
          tokenDecimals={dashboard.token.decimals}
          tokenBalance={dashboard.token.walletBalance}
          lpSymbol={dashboard.lp.symbol}
          lpBalance={dashboard.lp.walletBalance}
          holderClaimable={dashboard.holderLp.claimable}
          bnbClaimable={dashboard.lpTime.claimableBnb}
          loading={dashboard.isLoading}
        />
        <RewardFlow dashboard={dashboard} actions={actions} />
        {referral.enabled ? <ReferralBuyPanel /> : null}
        <section className="grid gap-4 lg:grid-cols-2">
          <HolderLpPanel dashboard={dashboard} />
          <LpTimePanel dashboard={dashboard} />
          <BuybackPanel dashboard={dashboard} />
          <SplitPanel dashboard={dashboard} />
          {referral.enabled ? <ReferralPanel referral={referral} /> : null}
        </section>
        <Footer />
      </div>

      <TxToast
        phase={actions.phase}
        hash={actions.hash}
        label={actions.label}
        error={actions.error}
        onClose={actions.reset}
      />
    </main>
  );
}
